module.exports = __webpack_public_path__ + "img/cover-minigame-bg.2c061f84.jpg";